import styled from 'styled-components';
import { Media } from 'assets/Mixins.style';
import { CMS as CommonContent } from 'assets/Common/CMS';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
  margin: 0 0 55px 0;

  ${Media.md`
    margin: 0 0 25px 0;
  `}
`;

export const Content = styled.article`
  ${CommonContent}
  color: ${props => props.theme.color};
`;
